module.exports = __webpack_public_path__ + "static/img/user.55f4877.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/user.jpg
// module id = f6Or
// module chunks = 16